import React, { useEffect } from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";
import teachingImg from "../images/teacher_experience.png";

const Step7 = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  // ONLY SHOW THIS PAGE IF USER IS A TEACHER
  useEffect(() => {
    if (student?.job !== "teacher") {
      window.location.href = "/step8";  // skip Step7
    }
  }, [student]);

  const handleSelect = async (value) => {
    try {
      const response = await fetch(
         `http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            teach_experience: value,
            current_step: "8",  // <-- TRACK NEXT STEP
          }),
        }
      );

      if (!response.ok) {
        alert("Failed to save teaching experience");
        return;
      }

      // UPDATE LOCAL STORAGE
      const updatedStudent = {
        ...student,
        teach_experience: value,
        current_step: "8",
      };
      localStorage.setItem("student", JSON.stringify(updatedStudent));

      window.location.href = "/step8";

    } catch (err) {
      console.error("Error updating:", err);
      alert("Server error");
    }
  };

  const options = [
    "Less than a year",
    "1 - 5 years",
    "5 - 10 years",
    "10 - 15 years",
    "Over 15 years",
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-400 text-white px-4">

      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6 z-20">
        <ProgressBar step={7} />
      </div>

      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold mt-10 text-yellow-300 drop-shadow-md text-center">
        How long have you been teaching?
      </h1>

      <div className="flex flex-col md:flex-row gap-10 mt-12 z-10 items-center">

        {/* IMAGE */}
        <img
          src={teachingImg}
          alt="Teaching"
          className="w-[280px] md:w-[420px] rounded-xl shadow-xl"
        />

        {/* OPTIONS */}
        <div className="flex flex-col gap-4">

          {options.map((opt, i) => (
            <motion.button
              key={i}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => handleSelect(opt)}
              className="bg-yellow-300 text-blue-900 font-bold py-3 px-6 rounded-full shadow-md text-lg md:text-xl"
            >
              {opt}
            </motion.button>
          ))}

          <p className="text-yellow-200 text-sm mt-2">
            Select one option to continue...
          </p>
        </div>
      </div>

      {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step7;
